// Activate fade-in only outside the Shopify theme editor.
// Editor leaves content visible by default (no opacity:0 initial state).
if (!(window.Shopify && window.Shopify.designMode)) {
  document.documentElement.classList.add('alsace-fade-ready');
}

(function () {
  // 各セクションが同じ<script src>を持つため、同一ページで複数回実行され
  // リスナーが多重登録される（数量が+2/+6ずつ増える）。初回のみ実行する。
  if (window.__alsaceProductLuxeInit) return;
  window.__alsaceProductLuxeInit = true;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function shrinkLastChar() {
    document.querySelectorAll('.info-title').forEach(function (el) {
      if (el.dataset.lastCharShrunk === '1') return;
      var text = (el.textContent || '').replace(/\s+$/, '');
      if (!text) return;
      // Use Array.from to handle surrogate pairs / multi-byte characters
      var chars = Array.from(text);
      if (chars.length < 2) return;
      var lastChar = chars.pop();
      var firstPart = chars.join('');
      el.innerHTML = escapeHtml(firstPart) + '<span class="info-title__last">' + escapeHtml(lastChar) + '</span>';
      el.dataset.lastCharShrunk = '1';
    });
  }

  function init() {
    shrinkLastChar();
    var root = document.querySelector('.alsace-product-luxe');
    if (!root) return;

    // ── Body-level shared popup for gallery hotspots (escapes stacking/clipping) ──
    var pop = document.createElement('div');
    pop.className = 'alsace-luxe-pop';
    pop.innerHTML =
      '<span class="pop__img"></span>' +
      '<span class="pop__body">' +
        '<span class="pop__name"></span>' +
        '<span class="pop__price"></span>' +
        '<span class="pop__cta">View →</span>' +
      '</span>';
    document.body.appendChild(pop);
    var popImg   = pop.querySelector('.pop__img');
    var popName  = pop.querySelector('.pop__name');
    var popPrice = pop.querySelector('.pop__price');

    var activeBtn = null;
    var activeUrl = '';
    var hideTimer = null;
    var popOpenedAt = 0;
    function cancelHide() { if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; } }
    function scheduleHide() { cancelHide(); hideTimer = setTimeout(hidePop, 120); }
    function positionPop() {
      if (!activeBtn) return;
      var r = activeBtn.getBoundingClientRect();
      var popW = pop.offsetWidth || 200;
      var popH = pop.offsetHeight || 280;
      var pad = 12;
      var left = r.left + r.width / 2 - popW / 2;
      if (left < pad) left = pad;
      if (left + popW > window.innerWidth - pad) left = window.innerWidth - popW - pad;
      var top = r.top - popH - 14;
      if (top < pad) top = r.bottom + 14;
      pop.style.left = left + 'px';
      pop.style.top = top + 'px';
    }
    function showPop(btn) {
      cancelHide();
      if (activeBtn !== btn) popOpenedAt = Date.now();
      activeBtn = btn;
      activeUrl = btn.getAttribute('data-url') || '';
      popImg.style.backgroundImage = "url('" + (btn.dataset.img || '') + "')";
      popName.textContent = btn.dataset.name || '';
      var price = btn.dataset.price || '';
      popPrice.innerHTML = price.replace(/^¥/, '<span class="yen">¥</span>');
      positionPop();
      pop.classList.add('is-open');
    }
    function hidePop() {
      activeBtn = null;
      pop.classList.remove('is-open');
    }

    // Preload hotspot card images so the pop shows instantly on first hover
    // (kept in an array so the requests aren't GC-cancelled)
    var hotspotPreloads = [];
    document.querySelectorAll('.alsace-product-luxe .hotspot').forEach(function (btn) {
      var src = btn.dataset.img;
      if (src) { var im = new Image(); im.src = src; hotspotPreloads.push(im); }
    });

    // On touch, pointerenter/focus fire before click on the same tap — they must
    // not open the pop (and set activeBtn), or the click handler would treat the
    // first tap as a second tap and navigate immediately.
    var lastPointerType = '';
    document.querySelectorAll('.alsace-product-luxe .hotspot').forEach(function (btn) {
      btn.addEventListener('pointerdown', function (e) { lastPointerType = e.pointerType || ''; }, { passive: true });
      btn.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'touch') showPop(btn);
      }, { passive: true });
      btn.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') scheduleHide();
      }, { passive: true });
      btn.addEventListener('focus', function () {
        if (lastPointerType !== 'touch') showPop(btn);
      }, { passive: true });
      btn.addEventListener('blur', function () { scheduleHide(); }, { passive: true });
      btn.addEventListener('click', function (ev) {
        // iOS Safari reports click's pointerType as 'mouse' even for taps
        // (click is a synthesized compatibility mouse event), so trust the
        // pointerdown-derived type first.
        var pt = lastPointerType || ev.pointerType || '';
        var url = btn.getAttribute('data-url') || '';
        if (pt === 'mouse') {
          if (url && url !== '#') { ev.preventDefault(); window.location.href = url; }
        } else {
          // Touch: first tap opens the card, tapping again (or the card) navigates.
          // The 350ms gate swallows ghost clicks fired within the same tap gesture,
          // whatever the device's event order — never navigate on the opening tap.
          ev.preventDefault();
          if (activeBtn === btn && Date.now() - popOpenedAt > 350) {
            if (url && url !== '#') window.location.href = url;
          } else if (activeBtn !== btn) {
            showPop(btn);
          }
        }
      });
    });
    pop.addEventListener('pointerenter', function () { cancelHide(); pop.classList.add('is-open'); });
    pop.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') scheduleHide();
    });
    pop.style.cursor = 'pointer';
    pop.addEventListener('click', function () {
      if (Date.now() - popOpenedAt < 350) return;
      if (activeUrl && activeUrl !== '#') window.location.href = activeUrl;
    });
    window.addEventListener('scroll', function () { if (activeBtn) positionPop(); }, { passive: true });
    window.addEventListener('resize', function () { if (activeBtn) positionPop(); }, { passive: true });
    document.addEventListener('touchstart', function (e) {
      if (!activeBtn) return;
      if (e.target.closest('.alsace-product-luxe .hotspot') || e.target.closest('.alsace-luxe-pop')) return;
      hidePop();
    }, { passive: true });

    // Main image slider ↔ thumbnail sync
    (function () {
      var slider = root.querySelector('.main-slider');
      var thumbs = root.querySelectorAll('.thumbs .thumb');
      if (!slider || !thumbs.length) return;
      var slides = slider.querySelectorAll('.main');
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          if (slides[i]) slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });
      var ticking = false;
      slider.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var idx = Math.round(slider.scrollLeft / slider.clientWidth);
          thumbs.forEach(function (t, i) { t.classList.toggle('active', i === idx); });
          ticking = false;
        });
      }, { passive: true });
      // Always open on the first image: browsers restore the slider's
      // horizontal scroll position on reload / back-forward navigation.
      function resetToFirst() {
        slider.scrollTo({ left: 0, behavior: 'instant' });
        var rail = root.querySelector('.thumbs');
        if (rail) rail.scrollTo({ left: 0, top: 0, behavior: 'instant' });
      }
      resetToFirst();
      window.addEventListener('pageshow', resetToFirst);

      // ── Prev/next arrows on the main image (PC) ──
      var navPrev = root.querySelector('.main-nav.prev');
      var navNext = root.querySelector('.main-nav.next');
      function curIdx() { return Math.round(slider.scrollLeft / (slider.clientWidth || 1)); }
      function navUpd() {
        if (!navPrev) return;
        var idx = curIdx();
        navPrev.disabled = idx <= 0;
        navNext.disabled = idx >= slides.length - 1;
      }
      function navGo(dir) {
        var idx = Math.max(0, Math.min(slides.length - 1, curIdx() + dir));
        if (slides[idx]) slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
      if (navPrev && navNext && slides.length > 1) {
        navPrev.addEventListener('click', function () { navGo(-1); });
        navNext.addEventListener('click', function () { navGo(1); });
        slider.addEventListener('scroll', navUpd, { passive: true });
        window.addEventListener('resize', navUpd);
        navUpd();
      }

      // ── Mouse drag-to-switch (touch devices already scroll natively) ──
      // ドラッグ中はスナップを外し、離した時に最寄りの写真へ吸着。
      // ドラッグ後のclickを抑止してライトボックスの誤オープンを防ぐ。
      var mDragging = false, mMoved = false, mStartX = 0, mStartLeft = 0, mSnapTimer = null;
      slider.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        mDragging = true; mMoved = false;
        mStartX = e.clientX; mStartLeft = slider.scrollLeft;
        if (mSnapTimer) { clearTimeout(mSnapTimer); mSnapTimer = null; }
        slider.style.scrollSnapType = 'none';
      });
      window.addEventListener('pointermove', function (e) {
        if (!mDragging) return;
        var dx = e.clientX - mStartX;
        if (Math.abs(dx) > 5) { mMoved = true; slider.classList.add('is-dragging'); }
        slider.scrollLeft = mStartLeft - dx;
      });
      function mEndDrag() {
        if (!mDragging) return;
        mDragging = false;
        slider.classList.remove('is-dragging');
        var idx = Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / (slider.clientWidth || 1))));
        slider.scrollTo({ left: idx * slider.clientWidth, behavior: 'smooth' });
        mSnapTimer = setTimeout(function () { slider.style.scrollSnapType = ''; }, 450);
      }
      window.addEventListener('pointerup', mEndDrag);
      window.addEventListener('pointercancel', mEndDrag);
      slider.addEventListener('click', function (e) {
        if (!mMoved) return;
        e.preventDefault();
        e.stopPropagation();
        mMoved = false;
      }, true);
      slider.querySelectorAll('img').forEach(function (im) { im.setAttribute('draggable', 'false'); });
    })();

    // Thumbnail rail arrows — scroll the thumbnail strip when there are more
    // thumbnails than fit. Works on desktop (vertical) and mobile (horizontal).
    (function () {
      var wrap = root.querySelector('.thumbs-wrap');
      var strip = root.querySelector('.thumbs');
      if (!wrap || !strip) return;
      var up = wrap.querySelector('.arrow.up');
      var down = wrap.querySelector('.arrow.down');
      if (!up || !down) return;
      function horiz() { return strip.scrollWidth > strip.clientWidth + 4; }
      function step() {
        var t = strip.querySelector('.thumb');
        if (!t) return 240;
        return horiz() ? (t.offsetWidth + 8) * 2 : (t.offsetHeight + 12) * 2;
      }
      function upd() {
        var h = horiz();
        var pos = h ? strip.scrollLeft : strip.scrollTop;
        var max = h ? (strip.scrollWidth - strip.clientWidth) : (strip.scrollHeight - strip.clientHeight);
        wrap.classList.toggle('no-scroll', max <= 4);
        up.classList.toggle('disabled', pos <= 2);
        down.classList.toggle('disabled', pos >= max - 2);
      }
      up.addEventListener('click', function () {
        if (up.classList.contains('disabled')) return;
        strip.scrollBy(horiz() ? { left: -step(), behavior: 'smooth' } : { top: -step(), behavior: 'smooth' });
      });
      down.addEventListener('click', function () {
        if (down.classList.contains('disabled')) return;
        strip.scrollBy(horiz() ? { left: step(), behavior: 'smooth' } : { top: step(), behavior: 'smooth' });
      });
      strip.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    })();

    // Main image lightbox — click/tap any main image to open a full-screen
    // popup with zoom (click image to magnify + pan) and image switching
    // (arrows / swipe / thumbnails).
    (function () {
      var slider = root.querySelector('.main-slider');
      if (!slider || root._luxeLightbox) return;
      var imgs = Array.prototype.slice.call(slider.querySelectorAll('.main'));
      if (!imgs.length) return;
      root._luxeLightbox = true;
      var items = imgs.map(function (el) {
        if (el.tagName === 'VIDEO') {
          var srcEl = el.querySelector('source');
          return { video: true, src: srcEl ? srcEl.src : el.src, thumb: el.getAttribute('data-poster') || el.poster };
        }
        return { video: false, src: el.getAttribute('data-zoom') || el.src, thumb: el.src };
      });
      var srcs = items.map(function (it) { return it.src; });

      var overlay = document.createElement('div');
      overlay.className = 'luxe-lightbox';
      overlay.innerHTML =
        '<button class="lb-close" type="button" aria-label="閉じる">×</button>' +
        '<button class="lb-nav lb-prev" type="button" aria-label="前へ"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><polyline points="15,4 7,12 15,20"/></svg></button>' +
        '<div class="lb-stage"><img alt=""><video controls muted loop playsinline style="display:none"></video></div>' +
        '<button class="lb-nav lb-next" type="button" aria-label="次へ"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><polyline points="9,4 17,12 9,20"/></svg></button>' +
        '<div class="lb-thumbs"></div>';
      document.body.appendChild(overlay);

      var stage = overlay.querySelector('.lb-stage');
      var stageImg = stage.querySelector('img');
      var stageVideo = stage.querySelector('video');
      var thumbsWrap = overlay.querySelector('.lb-thumbs');
      var current = 0;
      var single = srcs.length < 2;
      var zoomed = false;
      var ZOOM = 2;

      var thumbEls = [];
      items.forEach(function (it, i) {
        var t = document.createElement('button');
        t.type = 'button';
        t.className = 'lb-thumb';
        t.style.backgroundImage = "url('" + it.thumb + "')";
        thumbsWrap.appendChild(t);
        thumbEls.push(t);
      });

      if (single) {
        overlay.querySelector('.lb-prev').style.display = 'none';
        overlay.querySelector('.lb-next').style.display = 'none';
        thumbsWrap.style.display = 'none';
      }

      function pan(pt) {
        if (!zoomed) return;
        var r = stage.getBoundingClientRect();
        var x = Math.max(0, Math.min(100, (pt.clientX - r.left) / r.width * 100));
        var y = Math.max(0, Math.min(100, (pt.clientY - r.top) / r.height * 100));
        stageImg.style.transformOrigin = x + '% ' + y + '%';
      }
      function setZoom(on, pt) {
        zoomed = on;
        if (on) {
          if (pt) pan(pt);
          stageImg.style.transform = 'scale(' + ZOOM + ')';
          stageImg.classList.add('is-zoomed');
        } else {
          stageImg.classList.remove('is-zoomed');
          stageImg.style.transform = '';
          stageImg.style.transformOrigin = 'center center';
        }
      }
      function show(i) {
        current = (i + srcs.length) % srcs.length;
        setZoom(false);
        var it = items[current];
        if (it.video) {
          stageImg.style.display = 'none';
          stageVideo.style.display = 'block';
          if (stageVideo.getAttribute('src') !== it.src) stageVideo.src = it.src;
          stageVideo.play().catch(function () {});
        } else {
          stageVideo.pause();
          stageVideo.style.display = 'none';
          stageImg.style.display = 'block';
          stageImg.src = it.src;
        }
        thumbEls.forEach(function (t, j) { t.classList.toggle('active', j === current); });
      }
      function open(i) {
        show(i);
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      function close() {
        setZoom(false);
        stageVideo.pause();
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      imgs.forEach(function (el, i) {
        el.style.cursor = el.tagName === 'VIDEO' ? 'pointer' : 'zoom-in';
        el.addEventListener('click', function () { open(i); });
      });

      // Single delegated handler — robustly catches the close button, nav,
      // thumbnails, image-zoom toggle and backdrop, regardless of click target.
      overlay.addEventListener('click', function (e) {
        var thumb = e.target.closest('.lb-thumb');
        if (e.target.closest('.lb-close')) { close(); return; }
        if (e.target.closest('.lb-prev')) { show(current - 1); return; }
        if (e.target.closest('.lb-next')) { show(current + 1); return; }
        if (thumb) { show(thumbEls.indexOf(thumb)); return; }
        if (e.target === stageVideo) return;
        if (e.target === stageImg) { setZoom(!zoomed, e); return; }
        if (zoomed) { setZoom(false); return; }
        close();
      });

      stageImg.addEventListener('mousemove', function (e) { pan(e); }, { passive: true });

      document.addEventListener('keydown', function (e) {
        if (!overlay.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        else if (!single && e.key === 'ArrowLeft') show(current - 1);
        else if (!single && e.key === 'ArrowRight') show(current + 1);
      });

      var sx = 0, sy = 0, tracking = false;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (zoomed && e.touches.length === 1) pan(e.touches[0]);
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!tracking) return; tracking = false;
        if (zoomed || single) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
    })();

    // Variant button picker (drives hidden id input + redraws price)
    (function () {
      var form = root.querySelector('form[data-luxe-form]');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-luxe-price]');
      // 比較価格（受注生産テンプレートで設定ONの時だけ存在）
      var compareEl = root.querySelector('[data-luxe-compare]');
      var skuEl = root.querySelector('[data-luxe-sku]');
      var skuFallback = skuEl ? skuEl.textContent : '';
      var cartBtn = form.querySelector('.cart-btn');
      var restockNote = root.querySelector('[data-restock-note]');
      var variantsScript = root.querySelector('[data-luxe-variants]');
      var variants = [];
      if (variantsScript) {
        try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }
      }

      function findVariant(selectedOptions) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
        });
      }

      // Slide the gallery to the variant's featured image (media position is
      // 1-based and matches the render order of product.media in the slider).
      var slider = root.querySelector('.main-slider');
      var slides = slider ? slider.querySelectorAll('.main') : [];
      function showVariantImage(v, smooth) {
        if (!slider || !v || !v.media) return;
        var slide = slides[v.media - 1];
        if (!slide) return;
        var left = slider.scrollLeft + slide.getBoundingClientRect().left - slider.getBoundingClientRect().left;
        // 'instant' (not 'auto') so the no-animation case wins over any
        // scroll-behavior:smooth set in CSS.
        slider.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'instant' });
        // Bring the matching thumbnail into view in the rail
        // (vertical on desktop, horizontal on mobile — center it on both axes).
        var thumb = root.querySelectorAll('.thumbs .thumb')[v.media - 1];
        if (thumb) {
          var rail = thumb.parentElement;
          var tr = thumb.getBoundingClientRect();
          var rr = rail.getBoundingClientRect();
          rail.scrollTo({
            top: rail.scrollTop + tr.top - rr.top - (rr.height - tr.height) / 2,
            left: rail.scrollLeft + tr.left - rr.left - (rr.width - tr.width) / 2,
            behavior: smooth ? 'smooth' : 'instant'
          });
        }
      }

      function getSelectedOptions() {
        return Array.prototype.map.call(
          root.querySelectorAll('.variant-options[data-option-index]'),
          function (group) {
            var sel = group.querySelector('button.selected');
            return sel ? sel.getAttribute('data-value') : null;
          }
        );
      }

      // 現在の他オプションの選択を前提に、在庫のない選択肢をグレースケール表示にする
      function markSoldout() {
        var sel = getSelectedOptions();
        root.querySelectorAll('.variant-options[data-option-index]').forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          group.querySelectorAll('button').forEach(function (b) {
            var cand = sel.slice();
            cand[idx] = b.getAttribute('data-value');
            var v = findVariant(cand);
            b.classList.toggle('soldout', !v || !v.available);
          });
        });
      }

      function update() {
        var sel = getSelectedOptions();
        markSoldout();
        var v = findVariant(sel);
        if (!v) return;
        if (idInput) idInput.value = v.id;
        // Back in Stock アプリはURLの ?variant= で選択バリアントを検知するため、
        // 切り替え時にURLを同期してからインラインボタンを再判定させる
        try {
          var vUrl = new URL(window.location.href);
          vUrl.searchParams.set('variant', v.id);
          history.replaceState({}, '', vUrl);
        } catch (e) {}
        if (window.BIS && window.BIS.refreshInlineButton) {
          try { window.BIS.refreshInlineButton(); } catch (e) {}
        }
        showVariantImage(v, true);
        if (priceEl && v.price_html) priceEl.innerHTML = v.price_html + '<span class="tax">(税込)</span>';
        if (compareEl) {
          var cmp = v.compare_at_price || 0;
          var yen = function (c) { return '¥' + Math.round(c / 100).toLocaleString('ja-JP'); };
          if (cmp > v.price) {
            var amountEl = compareEl.querySelector('[data-compare-amount]');
            var saveEl = compareEl.querySelector('[data-compare-save]');
            if (amountEl) amountEl.textContent = yen(cmp);
            if (saveEl) saveEl.textContent = yen(cmp - v.price) + (compareEl.getAttribute('data-suffix') || '');
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (skuEl) skuEl.textContent = v.sku || skuFallback;
        if (cartBtn) {
          if (v.available) {
            cartBtn.disabled = false;
            cartBtn.textContent = cartBtn.getAttribute('data-default-text') || 'カートに入れる';
          } else {
            cartBtn.disabled = true;
            cartBtn.textContent = cartBtn.getAttribute('data-soldout-text') || 'SOLD OUT';
          }
        }
        // 再販案内（custom.restock_note がオンの商品のみ存在）は完売SKU選択中だけ表示
        if (restockNote) restockNote.hidden = !!v.available;
      }

      root.querySelectorAll('.variant-options[data-option-index] button').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var group = btn.closest('.variant-options');
          group.querySelectorAll('button').forEach(function (b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          update();
        });
      });

      // 初期表示でもグレー判定を行う（update()は画像スライドを伴うため呼ばない）
      markSoldout();
    })();

    // Quantity stepper
    (function () {
      var qty = root.querySelector('.qty');
      if (!qty) return;
      var input = qty.querySelector('input[name="quantity"]');
      var display = qty.querySelector('span');
      var minus = qty.querySelector('[data-qty="minus"]');
      var plus = qty.querySelector('[data-qty="plus"]');
      // 購入数の上限（受注生産テンプレートで設定した時だけ data-max がある）
      var max = parseInt(qty.getAttribute('data-max') || '0', 10);
      function set(n) {
        n = Math.max(1, n);
        if (max > 0) n = Math.min(max, n);
        if (input) input.value = n;
        if (display) display.textContent = n;
        if (plus && max > 0) plus.disabled = n >= max;
      }
      if (minus) minus.addEventListener('click', function (e) { e.preventDefault(); set(parseInt((input && input.value) || 1, 10) - 1); });
      if (plus)  plus.addEventListener('click',  function (e) { e.preventDefault(); set(parseInt((input && input.value) || 1, 10) + 1); });
    })();

    // Buy-together add-ons (e.g. storage case / gloves).
    // Checked items are added to the cart together with the tree via /cart/add.js.
    // With nothing checked the form falls through to its normal POST.
    (function () {
      var form = root.querySelector('form[data-luxe-form]');
      var wrap = root.querySelector('[data-luxe-addons]');
      if (!form || !wrap) return;

      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var cartBtn = form.querySelector('.cart-btn');

      var variants = [];
      var vScript = root.querySelector('[data-luxe-variants]');
      if (vScript) { try { variants = JSON.parse(vScript.textContent); } catch (e) {} }

      function mainVariant() {
        var id = idInput ? parseInt(idInput.value, 10) : 0;
        return variants.find(function (v) { return v.id === id; }) || null;
      }

      // Current tree size as a bare number ("150cm" -> "150"), from any selected option value
      function treeSizeNum() {
        var num = null;
        root.querySelectorAll('.variant-options button.selected').forEach(function (b) {
          var m = (b.getAttribute('data-value') || '').match(/(\d+)\s*cm/);
          if (m) num = m[1];
        });
        return num;
      }

      // When enabled (theme setting), sold-out variants are dropped entirely;
      // otherwise they stay visible, muted, labeled 売り切れ.
      var hideSoldout = wrap.hasAttribute('data-hide-soldout');

      var cards = [];
      wrap.querySelectorAll('[data-addon-card]').forEach(function (card) {
        var i = card.getAttribute('data-addon-index');
        var jsonEl = wrap.querySelector('[data-addon-json="' + i + '"]');
        var data = null;
        if (jsonEl) { try { data = JSON.parse(jsonEl.textContent); } catch (e) {} }
        if (!data || !data.variants || !data.variants.length) return;
        // "240=2,180=1" style map: tree size -> required units of this add-on
        var qtyMap = {};
        (card.getAttribute('data-qty-map') || '').split(',').forEach(function (pair) {
          var m = pair.match(/(\d+)\s*[=＝:：]\s*(\d+)/);
          if (m) qtyMap[m[1]] = parseInt(m[2], 10);
        });
        cards.push({
          el: card,
          check: card.querySelector('[data-addon-check]'),
          sizeEl: card.querySelector('[data-addon-size]'),
          priceEl: card.querySelector('[data-addon-price]'),
          qtyNoteEl: card.querySelector('[data-addon-qtynote]'),
          chipsEl: card.querySelector('[data-addon-chips]'),
          sizeLink: card.hasAttribute('data-size-link'),
          options: data.options || [],
          variants: data.variants,
          qtyMap: qtyMap,
          qty: 1,
          selections: {},
          current: null
        });
      });
      if (!cards.length) return;

      function fmtYen(cents) {
        return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
      }

      // Size-linked cards keep only variants whose option value carries the
      // selected tree size ("ツリー用【M】120/150cm" matches a 120cm or 150cm tree)
      function candidates(card) {
        var list = card.variants;
        if (card.sizeLink) {
          var num = treeSizeNum();
          if (num) {
            var re = new RegExp('(^|[^0-9])' + num + '([^0-9]|$)');
            list = list.filter(function (v) {
              return v.options.some(function (val) { return /cm/.test(val) && re.test(val); });
            });
          }
        }
        return list;
      }

      // Chips for options that still have more than one value (e.g. カラー)
      function renderChips(card, cand) {
        if (!card.chipsEl) return;
        var multi = [];
        card.options.forEach(function (name, idx) {
          var vals = [];
          cand.forEach(function (v) {
            if (vals.indexOf(v.options[idx]) === -1) vals.push(v.options[idx]);
          });
          if (vals.length > 1) multi.push({ idx: idx, vals: vals });
        });
        var seed = cand.find(function (v) { return v.available; }) || cand[0];
        multi.forEach(function (m) {
          if (card.selections[m.idx] == null || m.vals.indexOf(card.selections[m.idx]) === -1) {
            card.selections[m.idx] = seed.options[m.idx];
          }
        });
        Object.keys(card.selections).forEach(function (k) {
          if (!multi.some(function (m) { return String(m.idx) === String(k); })) delete card.selections[k];
        });
        if (!multi.length) { card.chipsEl.innerHTML = ''; return; }
        var html = '';
        multi.forEach(function (m) {
          html += '<span class="luxe-addon-chiprow">';
          m.vals.forEach(function (val) {
            var on = card.selections[m.idx] === val;
            html += '<button type="button" class="luxe-addon-chip' + (on ? ' on' : '') +
                    '" data-chip-idx="' + m.idx + '" data-chip-val="' + escapeHtml(val) + '">' +
                    escapeHtml(val) + '</button>';
          });
          html += '</span>';
        });
        card.chipsEl.innerHTML = html;
      }

      function updateCard(card) {
        var base = candidates(card);
        if (!base.length) {
          // No variant fits the selected tree size (e.g. 90cm): keep the card
          // visible but muted, labeled as not applicable.
          card.el.style.display = '';
          card.el.classList.add('is-soldout');
          if (card.check) { card.check.checked = false; card.check.disabled = true; }
          if (card.chipsEl) card.chipsEl.innerHTML = '';
          if (card.sizeEl) card.sizeEl.textContent = '';
          if (card.priceEl) card.priceEl.innerHTML = '<span class="oos">サイズ適応外</span>';
          if (card.qtyNoteEl) card.qtyNoteEl.textContent = '';
          card.current = null;
          return;
        }
        var cand = hideSoldout ? base.filter(function (v) { return v.available; }) : base;
        if (!cand.length) {
          card.el.style.display = 'none';
          if (card.check) card.check.checked = false;
          card.current = null;
          return;
        }
        card.el.style.display = '';
        renderChips(card, cand);
        var v = cand.find(function (x) {
          return Object.keys(card.selections).every(function (k) { return x.options[k] === card.selections[k]; });
        }) || cand[0];
        card.current = v;
        if (card.sizeEl) {
          var tag = '';
          if (card.sizeLink) {
            v.options.forEach(function (val) { if (/cm/.test(val)) tag = val.replace(/^ツリー用/, ''); });
          }
          card.sizeEl.textContent = tag;
        }
        card.qty = 1;
        if (card.sizeLink) {
          var num = treeSizeNum();
          if (num && card.qtyMap[num]) card.qty = card.qtyMap[num];
        }
        var soldout = !v.available;
        card.el.classList.toggle('is-soldout', soldout);
        if (card.check) {
          card.check.disabled = soldout;
          if (soldout) card.check.checked = false;
        }
        if (card.priceEl) {
          card.priceEl.innerHTML = soldout
            ? '<span class="oos">売り切れ</span>'
            : '+ ' + v.price_fmt +
              (card.qty > 1 ? ' <span class="mult">× ' + card.qty + '</span>' : '') +
              '<span class="tax">(税込)</span>';
        }
        if (card.qtyNoteEl) {
          var qtyNote = '';
          if (card.qty > 1) {
            qtyNote = '※ ' + treeSizeNum() + 'cmのツリーには' + card.qty + '個必要';
            qtyNote += soldout ? 'です。' : 'なため、' + card.qty + '個カートに入ります。';
          }
          card.qtyNoteEl.textContent = qtyNote;
        }
      }

      function pickedCards() {
        return cards.filter(function (c) { return c.check && c.check.checked && c.current && c.current.available; });
      }

      function updateButton() {
        if (!cartBtn) return;
        var mv = mainVariant();
        if (!mv || !mv.available) return;
        var picked = pickedCards();
        if (!picked.length) {
          cartBtn.textContent = cartBtn.getAttribute('data-default-text') || 'カートに入れる';
          return;
        }
        var qty = parseInt((qtyInput && qtyInput.value) || 1, 10);
        var units = qty;
        picked.forEach(function (c) { units += c.qty || 1; });
        var label = units + '点をカートに入れる';
        if (typeof mv.price === 'number') {
          var total = mv.price * qty;
          picked.forEach(function (c) { total += c.current.price * (c.qty || 1); });
          label += ' ・ 合計 ' + fmtYen(total);
        }
        cartBtn.textContent = label;
      }

      function updateAll() {
        cards.forEach(updateCard);
        updateButton();
      }

      cards.forEach(function (card) {
        if (card.check) card.check.addEventListener('change', updateButton);
        if (card.chipsEl) {
          card.chipsEl.addEventListener('click', function (e) {
            var chip = e.target.closest('.luxe-addon-chip');
            if (!chip) return;
            e.preventDefault();
            e.stopPropagation();
            card.selections[chip.getAttribute('data-chip-idx')] = chip.getAttribute('data-chip-val');
            updateCard(card);
            updateButton();
          });
        }
      });

      // These run after the variant-picker / qty handlers registered above,
      // so the main price and button state are already up to date.
      root.querySelectorAll('.variant-options[data-option-index] button').forEach(function (btn) {
        btn.addEventListener('click', updateAll);
      });
      root.querySelectorAll('.qty [data-qty]').forEach(function (btn) {
        btn.addEventListener('click', updateButton);
      });

      form.addEventListener('submit', function (e) {
        var picked = pickedCards();
        if (!picked.length) return;
        e.preventDefault();
        var items = [];
        var main = {
          id: parseInt(idInput.value, 10),
          quantity: parseInt((qtyInput && qtyInput.value) || 1, 10)
        };
        var props = {};
        form.querySelectorAll('[name^="properties["]').forEach(function (el) {
          var m = el.name.match(/^properties\[(.+)\]$/);
          if (m && el.value) props[m[1]] = el.value;
        });
        if (Object.keys(props).length) main.properties = props;
        items.push(main);
        picked.forEach(function (c) { items.push({ id: c.current.id, quantity: c.qty || 1 }); });

        var cartUrl = (form.getAttribute('action') || '/cart/add').replace(/\/add.*$/, '');
        if (cartBtn) { cartBtn.disabled = true; cartBtn.textContent = '追加しています…'; }
        fetch(cartUrl + '/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart add failed: ' + r.status);
          window.location.href = cartUrl;
        }).catch(function () {
          if (cartBtn) cartBtn.disabled = false;
          form.submit();
        });
      });

      updateAll();
    })();

    // Add-on detail popup: the compact card opens a detail sheet on tap;
    // the checkbox (and option chips) still toggle inline without opening it.
    (function () {
      var wrap = root.querySelector('[data-luxe-addons]');
      if (!wrap) return;
      var openPop = null;

      function close() {
        if (!openPop) return;
        openPop.hidden = true;
        openPop = null;
        document.body.style.overflow = '';
      }

      wrap.querySelectorAll('[data-addon-card]').forEach(function (card) {
        var pop = wrap.querySelector('[data-addon-pop="' + card.getAttribute('data-addon-index') + '"]');
        if (!pop) return;
        var check = card.querySelector('[data-addon-check]');
        var priceEl = card.querySelector('[data-addon-price]');
        var popPrice = pop.querySelector('[data-pop-price]');
        var addBtn = pop.querySelector('[data-pop-add]');

        function open() {
          // Mirror the card's live price/state (size-linked price, ×N, 売り切れ, サイズ適応外)
          if (popPrice && priceEl) popPrice.innerHTML = priceEl.innerHTML;
          if (addBtn) {
            if (check && check.disabled) addBtn.textContent = '閉じる';
            else if (check && check.checked) addBtn.textContent = 'チェックを外す';
            else addBtn.textContent = '一緒に購入する';
          }
          pop.hidden = false;
          openPop = pop;
          document.body.style.overflow = 'hidden';
        }

        card.addEventListener('click', function (e) {
          if (e.target.closest('[data-addon-checkwrap]')) return;
          if (e.target.closest('.luxe-addon-chip')) return;
          open();
        });

        if (addBtn) {
          addBtn.addEventListener('click', function () {
            if (check && !check.disabled) {
              check.checked = !check.checked;
              check.dispatchEvent(new Event('change', { bubbles: true }));
            }
            close();
          });
        }
        pop.querySelectorAll('[data-pop-close]').forEach(function (el) {
          el.addEventListener('click', close);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    })();

    // Share button (Web Share API w/ clipboard fallback)
    (function () {
      var btn = root.querySelector('.share-btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var url = window.location.href;
        var title = document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            var span = btn.querySelector('span');
            if (!span || btn.dataset.copied) return;
            var orig = span.textContent;
            btn.dataset.copied = '1';
            span.textContent = 'リンクをコピーしました';
            setTimeout(function () {
              span.textContent = orig;
              delete btn.dataset.copied;
            }, 2000);
          });
        }
      });
    })();

    // IntersectionObserver fade-in (scan ALL alsace-product-luxe wrappers, not just `root`)
    var targets = document.querySelectorAll('.alsace-product-luxe .feat, .alsace-product-luxe .rv');
    var inDesignMode = !!(window.Shopify && window.Shopify.designMode);
    if (inDesignMode) {
      // In the Shopify theme editor the IO can be unreliable inside the preview
      // iframe (scroll position, off-viewport rendering). Reveal everything.
      targets.forEach(function (el) { el.classList.add('in'); });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) e.target.classList.add('in');
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      targets.forEach(function (el) { io.observe(el); });
      // Safety net: if anything is still hidden after 1500ms (e.g. IO never
      // fired because the element was off-viewport on load), reveal it.
      setTimeout(function () {
        targets.forEach(function (el) {
          if (!el.classList.contains('in')) {
            var r = el.getBoundingClientRect();
            if (r.top < window.innerHeight && r.bottom > 0) {
              el.classList.add('in');
            }
          }
        });
      }, 1500);
    } else {
      targets.forEach(function (el) { el.classList.add('in'); });
    }

    // Re-trigger fade when scrolled back near the top
    window.addEventListener('scroll', function () {
      if (window.scrollY < 50) {
        targets.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top >= window.innerHeight) el.classList.remove('in');
        });
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor re-renders sections in-place. Reveal newly rendered
  // .feat / .rv elements so they don't stay invisible (opacity:0) in the editor.
  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target || document;
    scope.querySelectorAll('.alsace-product-luxe .feat, .alsace-product-luxe .rv').forEach(function (el) {
      el.classList.add('in');
    });
  });
})();
